import FooterC from "../components/FooterComp";
import Guests from "../components/Guests";
import HomeEvents from "../components/HomeEvents";
import Landing from "../components/Landing";
import { Analytics } from "@vercel/analytics/react";

// import LogosSlider from "../components/SponsorsSlider";
import Header from "./Header";
const Home = ({ settingmenu }) => {
  return (
    <>
      <Analytics />
      <Header settingmenu={settingmenu} />
      <Landing />
      <Guests />
      <HomeEvents />
      {/* <LogosSlider/> */}
      <FooterC />
    </>
  );
};

export default Home;
